import {
  MENTOR_REPLY_TIME,
  SUBSCRIPTION,
  type Subscription
} from '@algoacademy/backend/modules/marketplace/enums'

export const BASIC_MENTORING_BASE_PRICE = 399
export const ADVANCED_MENTORING_BASE_PRICE = 199

export const MINIMUM_HOURS_WITH_MENTOR = 2
export const MAXIMUM_HOURS_WITH_MENTOR = 40
export const DEFAULT_HOURS_WITH_MENTOR = 8
export const PRICE_OF_ONE_HOUR_WITH_MENTOR = 200

export const APPLICATION_HELP_PRICE = 430
export const CUSTOMIZED_TASKS_PRICE = 790

export const MINIMUM_LINES_OF_CODE = 1000
export const MAXIMUM_LINES_OF_CODE = 10_000
export const DEFAULT_LINES_OF_CODE = 1000
export const PRICE_OF_1000_LINES_OF_CODE = 190

export const MENTOR_REPLY_TIME_PRICES = {
  [MENTOR_REPLY_TIME.STANDARD]: 0,
  [MENTOR_REPLY_TIME.MEDIUM]: 400,
  [MENTOR_REPLY_TIME.PRIORITY]: 1200
}

export const BASIC_MENTORING_DISCOUNT_PER_CENT = {
  [SUBSCRIPTION.PER_4_WEEKS]: 0,
  [SUBSCRIPTION.PER_12_WEEKS]: 8,
  [SUBSCRIPTION.YEARLY]: 17
}

export const ADVANCED_MENTORING_DISCOUNT_PER_CENT = {
  [SUBSCRIPTION.PER_4_WEEKS]: 0,
  [SUBSCRIPTION.PER_12_WEEKS]: 8,
  [SUBSCRIPTION.YEARLY]: 17
}

export function roundUpToNearestZloty(price: number): number {
  return Math.ceil(price)
}

export function calculateBasicMentoringPrice(): number {
  return roundUpToNearestZloty(BASIC_MENTORING_BASE_PRICE)
}

export function calculateAdvancedMentoringPrice(config: {
  hoursWithMentor: number
  mentorReplyTime: string
  linesOfCode: number
  applicationHelp: number
  careerCoaching: number
}): number {
  const { hoursWithMentor, mentorReplyTime, linesOfCode, applicationHelp, careerCoaching } = config

  const totalPrice =
    ADVANCED_MENTORING_BASE_PRICE +
    hoursWithMentor * PRICE_OF_ONE_HOUR_WITH_MENTOR +
    APPLICATION_HELP_PRICE * applicationHelp +
    CUSTOMIZED_TASKS_PRICE * careerCoaching +
    MENTOR_REPLY_TIME_PRICES[mentorReplyTime as keyof typeof MENTOR_REPLY_TIME_PRICES] +
    (linesOfCode * PRICE_OF_1000_LINES_OF_CODE) / 1000

  return roundUpToNearestZloty(totalPrice)
}

export function getPeriodsCount(subscription: Subscription): number {
  switch (subscription) {
    case SUBSCRIPTION.PER_4_WEEKS: {
      return 1
    }
    case SUBSCRIPTION.PER_12_WEEKS: {
      return 3
    }
    case SUBSCRIPTION.YEARLY: {
      return 13
    }
    default: {
      return 1
    }
  }
}

export function calculatePriceForSubscription(
  basePricePerFourWeeks: number,
  subscription: Subscription,
  discountPerCent: number
): {
  originalPrice: number
  discountedPrice: number
  savings: number
  periodsCount: number
} {
  const periodsCount = getPeriodsCount(subscription)
  const originalPrice = roundUpToNearestZloty(basePricePerFourWeeks * periodsCount)
  const discountedPrice = roundUpToNearestZloty(
    originalPrice - (originalPrice * discountPerCent) / 100
  )
  const savings = originalPrice - discountedPrice

  return {
    originalPrice,
    discountedPrice,
    savings,
    periodsCount
  }
}
